<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body" class="tabs-container pt-2 px-6">
		<vue-perfect-scrollbar class="scroll-area--form" :settings="settingsForm">
			<vs-alert
				v-if="optimizersList.length > 1"
				class="mb-2"
				:active.sync="closeInfo"
				closable
				icon-pack="feather"
				close-icon="icon-x"
			>
				<span>{{ $t("FieldsWithTheIndicatedIconsAreCompatible") }}</span>
				<div class="flex items-center justify-around">
					<span class="flex items-center">
						<i class="material-icons mr-1 text-danger font-bold" style="font-size: 16px"> adjust </i
						>{{ "Openroute" }}
					</span>
					<span class="flex items-center">
						<i class="material-icons mr-1 text-warning font-bold" style="font-size: 16px"> cloud_circle </i
						>{{ "Gmpro" }}
					</span>
					<span class="flex items-center">
						<i class="material-icons mr-1 text-success font-bold" style="font-size: 15px">
							assistant_direction </i
						>{{ "Tour Planning" }}
					</span>
				</div>
			</vs-alert>
			<div class="vx-row">
				<vs-alert
					color="danger"
					class="mb-2 mr-4 ml-4"
					closable
					icon-pack="feather"
					close-icon="icon-x"
					:active.sync="activeAlertError"
					:title="$t('ManualData.ManageError')"
				>
					<vs-list>
						<vs-list-item
							v-for="(item, index) of listErrorFilter"
							:key="index"
							:title="index + 1 + '. ' + item.message"
						></vs-list-item>
					</vs-list>
				</vs-alert>
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<vx-card :cardBorder="true" :noShadow="true" :title="$t('GeneralInformation')">
						<form data-vv-scope="update-resource">
							<div class="vx-row">
								<!--IDENTIFICATION -->
								<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
									<vs-tooltip
										v-if="validateErrorProperty('identification').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{
											$t("Routing.Table.Identification")
										}}</label>
										<span
											@click.prevent="
												showPromptError('identification', $t('Routing.Table.Identification'))
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label">{{
										$t("Routing.Table.Identification")
									}}</label>
									<vs-input
										class="w-full"
										v-model="resource.identification"
										v-validate="'required'"
										name="identification"
										:disabled="isDisabledIdentification"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('update-resource.identification')"
										>{{ $t("ResourceModule.BasicInfoForm.ValidMessages.Identification") }}</span
									>
								</div>
								<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
									<small class="flex items-center date-label cursor-pointer">
										{{ $t("IdentificationOfOrigin") }}
										<i
											class="material-icons text-primary ml-1"
											style="font-size: 14px"
											:title="$t('IdentificationOfOriginText')"
										>
											info
										</i>
									</small>
									<vs-input
										class="w-full"
										v-model="resource.original_identification"
										name="original_identification"
									/>
								</div>
							</div>
							<div class="vx-row mt-2">
								<div
									class="vx-col w-full"
									:class="{
										'md:w-1/2 sm:w-1/2': !(
											optimizersList.length === 1 && optimizersList[0] === 'OPENROUTE'
										),
									}"
								>
									<vs-tooltip
										v-if="validateErrorProperty('profile').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{ $t("Profile") }}</label>
										<span @click.prevent="showPromptError('profile', $t('Profile'))"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label">{{ $t("Profile") }}</label>
									<v-select
										v-model="resource.profile"
										name="country"
										:clearable="false"
										:options="profileOptions"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
											<template v-else>
												{{ $t("NoResultsFound") }}
											</template>
										</template>
									</v-select>
								</div>
								<div
									v-if="!(optimizersList.length === 1 && optimizersList[0] === 'OPENROUTE')"
									class="vx-col md:w-1/2 sm:w-1/2 w-full"
								>
									<vs-tooltip
										v-if="validateErrorProperty('maxtraveldistance').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{
											$t("ResourceModule.Create.MaxTravelDistance") + " " + "(Mts)"
										}}</label>
										<span
											@click.prevent="
												showPromptError(
													'maxtraveldistance',
													$t('ResourceModule.Create.MaxTravelDistance')
												)
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<small v-else class="flex items-center date-label cursor-pointer">
										{{ $t("ResourceModule.Create.MaxTravelDistance") + " " + "(Mts)" }}
										<span class="flex items-center" v-if="optimizersList.length > 1">
											<i
												class="material-icons ml-1 mr-1 text-warning font-bold"
												style="font-size: 14px"
												title="Gmpro"
											>
												cloud_circle
											</i>
											<i
												class="material-icons text-success font-bold"
												style="font-size: 13px"
												title="Tour Planning"
											>
												assistant_direction
											</i>
										</span>
									</small>
									<vs-input
										v-model.trim="resource.max_travel_distance"
										class="w-full"
										type="text"
										:placeholder="$t('ResourceModule.Create.MaxTravelDistance')"
										:vs-placeholder="$t('ResourceModule.Create.MaxTravelDistance')"
										@keypress="validateAmountNumber"
									/>
								</div>
							</div>
							<div
								v-if="optimizersList.length > 0 && optimizersList.includes('GMPRO')"
								class="vx-row mt-2"
							>
								<div class="vx-col w-full">
									<vs-tooltip
										v-if="validateErrorProperty('maxtravelduration').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{
											$t("ResourceModule.Create.MaxServiceTime")
										}}</label>
										<span
											@click.prevent="
												showPromptError(
													'maxtravelduration',
													$t('ResourceModule.Create.MaxServiceTime')
												)
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<small v-else class="flex items-center date-label cursor-pointer">
										{{ $t("ResourceModule.Create.MaxServiceTime") }}
										<i
											v-if="optimizersList.length > 1"
											class="material-icons ml-1 text-warning font-bold"
											style="font-size: 14px"
											title="Gmpro"
										>
											cloud_circle
										</i>
									</small>
									<div class="flex flex-row justify-between">
										<vs-input-number
											v-model="resource.hours"
											class="w-1/4 mr-4"
											:label="$t('RouterSelection.Hours')"
											:min="0"
											:max="24"
											@keypress="validateInputNumber"
										/>
										<vs-input-number
											v-model="resource.minutes"
											class="w-full"
											:label="$t('RouterSelection.Minutes')"
											:min="0"
											:max="59"
											@keypress="validateInputNumberMinutes"
										/>
										<vs-input-number
											v-model="resource.seconds"
											class="w-full ml-4"
											:label="$t('RouterSelection.Seconds')"
											:min="0"
											:max="59"
											@keypress="validateInputNumberSeconds"
										/>
									</div>
								</div>
							</div>
							<div class="vx-row mt-2">
								<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
									<vs-tooltip
										v-if="validateErrorProperty('init_depot').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{
											$t("Deposits.Form.StartDeposit")
										}}</label>
										<span
											@click.prevent="
												showPromptError('init_depot', $t('Deposits.Form.StartDeposit'))
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label">{{ $t("Deposits.Form.StartDeposit") }}</label>
									<vx-input-group>
										<vs-input
											name="startdeposit"
											type="text"
											class="w-full"
											v-model="resource.init_depot"
											v-validate="'required'"
											:placeholder="'E.j: 6.182280, -75.598677'"
											:disabled="true"
										/>
										<template slot="append">
											<div class="append-text btn-addon">
												<vs-button
													color="primary"
													icon-pack="feather"
													icon="icon-plus"
													:title="$t('Add') + ' ' + $t('Routing.Map.Coordinates')"
													@click.prevent="openMapInitDeposit()"
												></vs-button>
											</div>
										</template>
									</vx-input-group>
									<span
										class="text-danger text-sm"
										v-show="errors.has('update-resource.startdeposit')"
										>{{
											$t("Routing.AssignColumns.Text1") + " " + $t("Routing.AssignColumns.Text2")
										}}</span
									>
								</div>
								<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
									<vs-tooltip
										v-if="validateErrorProperty('end_depot').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{ $t("Deposits.Form.EndDeposit") }}</label>
										<span
											@click.prevent="
												showPromptError('end_depot', $t('Deposits.Form.EndDeposit'))
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label">{{ $t("Deposits.Form.EndDeposit") }}</label>
									<vx-input-group>
										<vs-input
											name="enddeposit"
											type="text"
											class="w-full"
											v-model="resource.end_depot"
											:placeholder="'E.j: 6.182280, -75.598677'"
											:disabled="true"
										/>
										<template slot="append">
											<div class="append-text btn-addon">
												<vs-button
													v-if="resource.end_depot !== ''"
													color="danger"
													icon-pack="feather"
													icon="icon-trash-2"
													:title="$t('Crud.Delete') + ' ' + $t('Routing.Map.Coordinates')"
													@click.prevent="resource.end_depot = ''"
												></vs-button>
												<vs-button
													color="primary"
													icon-pack="feather"
													icon="icon-plus"
													:title="$t('Add') + ' ' + $t('Routing.Map.Coordinates')"
													@click.prevent="openMapEndDeposit()"
												></vs-button>
											</div>
										</template>
									</vx-input-group>
								</div>
							</div>
						</form>
					</vx-card>
					<vx-card class="mt-base" :cardBorder="true" :noShadow="true" :title="$t('MODULE_SOURCE.Costs')">
						<form>
							<div class="vx-row">
								<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
									<vs-tooltip
										v-if="validateErrorProperty('fixed_cost').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{
											$t("ResourceModule.Costs.Fixed cost")
										}}</label>
										<span
											@click.prevent="
												showPromptError('fixed_cost', $t('ResourceModule.Costs.Fixed cost'))
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label">{{
										$t("ResourceModule.Costs.Fixed cost")
									}}</label>
									<vs-input
										class="w-full"
										v-model="resource.costs.fixed"
										@keypress="validateAmountNumber"
									/>
								</div>
								<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
									<vs-tooltip
										v-if="validateErrorProperty('distance_cost').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{
											$t("ResourceModule.Costs.Cost per kilometer of the vehicle route")
										}}</label>
										<span
											@click.prevent="
												showPromptError(
													'distance_cost',
													$t('ResourceModule.Costs.Cost per kilometer of the vehicle route')
												)
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label">{{
										$t("ResourceModule.Costs.Cost per kilometer of the vehicle route")
									}}</label>
									<vs-input
										class="w-full"
										v-model="resource.costs.distance"
										@keypress="validateAmountNumber"
									/>
								</div>
							</div>
							<div class="vx-row mt-2">
								<div
									class="vx-col w-full"
									:class="{
										'md:w-1/2 sm:w-1/2':
											optimizersList.length > 0 && optimizersList.includes('GMPRO'),
									}"
								>
									<vs-tooltip
										v-if="validateErrorProperty('time_cost').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{
											$t("ResourceModule.Costs.Cost per hour of the vehicle route")
										}}</label>
										<span
											@click.prevent="
												showPromptError(
													'time_cost',
													$t('ResourceModule.Costs.Cost per hour of the vehicle route')
												)
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label">{{
										$t("ResourceModule.Costs.Cost per hour of the vehicle route")
									}}</label>
									<vs-input
										class="w-full"
										v-model="resource.costs.time"
										@keypress="validateAmountNumber"
									/>
								</div>
								<div
									v-if="optimizersList.length > 0 && optimizersList.includes('GMPRO')"
									class="vx-col md:w-1/2 sm:w-1/2 w-full"
								>
									<vs-tooltip
										v-if="validateErrorProperty('traveledhourcost').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{
											$t("ResourceModule.Costs.Cost per traveled hour of the vehicle route")
										}}</label>
										<span
											@click.prevent="
												showPromptError(
													'traveledhourcost',
													$t(
														'ResourceModule.Costs.Cost per traveled hour of the vehicle route'
													)
												)
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="flex items-center vs-input--label cursor-pointer">
										{{ $t("ResourceModule.Costs.Cost per traveled hour of the vehicle route") }}
										<i
											v-if="optimizersList.length > 1"
											class="material-icons ml-1 text-warning font-bold"
											style="font-size: 14px"
											title="Gmpro"
										>
											cloud_circle
										</i>
									</label>
									<vs-input
										class="w-full"
										v-model="resource.costs.traveled_hour"
										@keypress="validateAmountNumber"
									/>
								</div>
							</div>
						</form>
					</vx-card>
					<vx-card
						v-if="optimizersList.length > 0 && optimizersList.includes('TOUR_PLANNING')"
						class="mt-base"
						:cardBorder="true"
						:noShadow="true"
						:title="$t('ClusteredRouteParameters')"
					>
						<template slot="actions">
							<i
								v-if="optimizersList.length > 1"
								class="material-icons text-success cursor-pointer font-bold"
								style="font-size: 14px"
								title="Tour Planning"
							>
								assistant_direction
							</i>
							<i
								class="material-icons text-secondary ml-1 mr-1 cursor-pointer text-primary"
								style="font-size: 16px"
								:title="$t('ClusteredRouteParametersText')"
							>
								info
							</i>
							<feather-icon
								v-if="!isClusteredRoute"
								icon="PlusIcon"
								svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
								:title="$t('Add') + ' ' + $t('ClusteredRouteParameters')"
								@click.prevent="isClusteredRoute = true"
							/>
							<feather-icon
								v-else
								icon="Trash2Icon"
								svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
								:title="$t('Crud.Delete') + ' ' + $t('ClusteredRouteParameters')"
								@click.prevent="isClusteredRoute = false"
							/>
						</template>
						<div v-if="isClusteredRoute" class="vx-row">
							<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
								<small class="flex items-center date-label cursor-pointer">
									{{ $t("MaximumDistance") + " (mts)" }}
									<i
										class="material-icons ml-1"
										style="font-size: 14px"
										:title="$t('MaximumDistanceClusterText')"
									>
										info
									</i>
								</small>
								<vs-input
									type="number"
									class="w-full"
									v-model="resource.clustering.max_distance_to_neighbor"
									name="MaxDistanceToNeighbor"
									v-validate="'max_value:75'"
									@blur="checkZeroMaxDistanceToNeighbor"
									@keypress="validateAmountNumber"
								/>
								<span class="text-danger text-sm" v-show="errors.has('MaxDistanceToNeighbor')">
									{{ $t("Optimization.Messages.maximum") + ": " + "75" }}</span
								>
							</div>
							<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
								<small class="flex items-center date-label cursor-pointer">
									{{ $t("MaximumDiameter") + " (mts)" }}
									<i
										class="material-icons ml-1"
										style="font-size: 14px"
										:title="$t('MaximumDiameterClusterText')"
									>
										info
									</i>
								</small>
								<vs-input
									type="number"
									class="w-full"
									v-model="resource.clustering.max_diameter"
									name="MaxDiameter"
									v-validate="'max_value:1000'"
									@blur="checkZeroMaxDiameter"
									@keypress="validateAmountNumber"
								/>
								<span class="text-danger text-sm" v-show="errors.has('MaxDiameter')">
									{{ $t("Optimization.Messages.maximum") + ": " + "1000" }}</span
								>
							</div>
						</div>
						<vs-alert v-else active class="mb-5" color="#a3a1a1">
							<span> {{ $t("NoRoutingParametersAssigned") }} </span>
						</vs-alert>
					</vx-card>
					<vx-card class="mt-base" :cardBorder="true" :noShadow="true" :title="$t('TimeWindow.TimeWindows')">
						<template slot="actions">
							<vs-button
								v-if="!isTimeWindow"
								class="ml-2 mr-2 font-bold"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-plus"
								@click.prevent="addTimeWindow()"
								>{{ $t("Add") }}
							</vs-button>
							<feather-icon
								v-else
								icon="Trash2Icon"
								svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
								:title="$t('Crud.Delete') + ' ' + $t('TimeWindow.TimeWindow')"
								@click.prevent="deleteTimeWindow()"
							/>
						</template>
						<div v-if="isTimeWindow">
							<form>
								<div class="vx-row">
									<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
										<small class="date-label">{{ $t("CompanyCreate.InitDate") }}</small>
										<datepicker
											name="initDate"
											v-model="resource.time_window.init_date_window"
											:language="$vs.rtl ? langHe : langEn"
											:disabledDates="disabledDatesTo"
											:placeholder="$t('Select')"
										></datepicker>
									</div>
									<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
										<small class="date-label">{{ $t("CompanyCreate.EndDate") }}</small>
										<datepicker
											name="endDate"
											v-model="resource.time_window.end_date_window"
											:language="$vs.rtl ? langHe : langEn"
											:disabledDates="disabledDatesTo"
											:placeholder="$t('Select')"
										></datepicker>
									</div>
									<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
										<small class="date-label">{{ $t("Routing.Table.InitHour") }}</small>
										<flat-pickr
											name="dataHourInit"
											class="w-full"
											v-model="resource.time_window.init_hour_window"
											:config="configdateTimePicker"
											:placeholder="$t('SelectInitTime')"
										/>
									</div>
									<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
										<small class="date-label">{{ $t("Routing.Table.EndHour") }}</small>
										<flat-pickr
											name="dataHourEnd"
											v-model="resource.time_window.end_hour_window"
											class="w-full"
											:config="configdateTimePicker"
											:placeholder="$t('SelectEndTime')"
										/>
									</div>
								</div>
							</form>
							<div v-if="optimizersList.length > 0 && optimizersList.includes('GMPRO')">
								<div
									v-if="!isSoftTimeWindow"
									class="flex items-center justify-between p-2 mt-2"
									style="border: 1px solid #ccc; border-radius: 5px"
								>
									<h5 class="flex items-center">
										{{ $t("TimeWindow.SoftTimeWindow") }}
										<i
											v-if="optimizersList.length > 1"
											class="material-icons ml-1 text-warning cursor-pointer font-bold"
											style="font-size: 14px"
											title="Gmpro"
										>
											cloud_circle
										</i>
									</h5>
									<vs-button
										class="font-bold"
										icon-pack="feather"
										icon="icon-plus"
										type="flat"
										size="small"
										@click.prevent="AddSofTimeWindow()"
										><small style="font-size: 13px">{{ $t("Teams.Form.Add") }}</small>
									</vs-button>
								</div>
								<vx-card
									v-else
									class="mt-2"
									:title="$t('TimeWindow.SoftTimeWindow')"
									:cardBorder="true"
									:noShadow="true"
								>
									<template slot="actions">
										<i
											v-if="optimizersList.length > 1"
											class="material-icons ml-1 text-warning cursor-pointer font-bold"
											style="font-size: 14px"
											title="Gmpro"
										>
											cloud_circle
										</i>
										<feather-icon
											icon="Trash2Icon"
											svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
											:title="$t('Crud.Delete') + ' ' + $t('TimeWindow.SoftTimeWindow')"
											@click.prevent="deleteSoftWindow"
										/>
									</template>
									<form>
										<div class="vx-row">
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{ $t("CompanyCreate.InitDate") }}</small>
												<datepicker
													v-model="resource.time_window.soft_time_window.init_date"
													name="initDateSoftWindow"
													:language="$vs.rtl ? langHe : langEn"
													:placeholder="$t('Select')"
												></datepicker>
												<span
													class="text-danger text-sm"
													v-if="
														isStartBeforeEnd(resource.time_window, 'init_date', 'end_date')
													"
													>{{ $t("BreakForm.ErrorMessages.DateInitError") }}</span
												>
												<span
													class="text-danger text-sm"
													v-else-if="
														showErrorSoftWindow(
															resource.time_window,
															'init_date_window',
															'init_date'
														)
													"
													>{{ $t("TheStartDateMust") }}</span
												>
											</div>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{ $t("CompanyCreate.EndDate") }}</small>
												<datepicker
													v-model="resource.time_window.soft_time_window.end_date"
													name="endDateSoftWindow"
													:language="$vs.rtl ? langHe : langEn"
													:placeholder="$t('Select')"
												></datepicker>
												<span
													class="text-danger text-sm"
													v-show="
														showErrorSoftWindow(
															resource.time_window,
															'end_date_window',
															'end_date'
														)
													"
													>{{ $t("TheEndDateMust") }}</span
												>
											</div>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{ $t("Routing.Table.InitHour") }}</small>
												<flat-pickr
													class="w-full"
													v-model="resource.time_window.soft_time_window.init_hour"
													name="dataHourInitSoftWindow"
													:config="configdateTimePicker"
													:placeholder="$t('Select')"
												/>
												<span
													class="text-danger text-sm"
													v-if="
														isStartBeforeEnd(resource.time_window, 'init_hour', 'end_hour')
													"
													>{{ $t("BreakForm.ErrorMessages.ValidInitHour") }}</span
												>
												<span
													class="text-danger text-sm"
													v-else-if="
														showErrorSoftWindowHour(
															resource.time_window,
															'init_hour_window',
															'init_hour'
														)
													"
													>{{ $t("TheStartTimeMust") }}</span
												>
											</div>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{ $t("Routing.Table.EndHour") }}</small>
												<flat-pickr
													v-model="resource.time_window.soft_time_window.end_hour"
													class="w-full"
													name="dataHourEndSoftWindow"
													:placeholder="$t('Select')"
													:config="configdateTimePicker"
												/>
												<span
													class="text-danger text-sm"
													v-show="
														showErrorSoftWindowHour(
															resource.time_window,
															'end_hour_window',
															'end_hour'
														)
													"
													>{{ $t("TheEndTimeMust") }}</span
												>
											</div>
										</div>
										<div class="vx-row">
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{
													$t("TimeWindow.PenaltyForAnticipation")
												}}</small>
												<vs-input
													type="number"
													class="w-full"
													v-model="resource.time_window.soft_time_window.cost_per_hour_before"
													name="penaltyForAnticipation"
													@blur="validatePerCost()"
													@keypress="validateAmountNumber"
												/>
											</div>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{
													$t("TimeWindow.PenaltyForLateness")
												}}</small>
												<vs-input
													type="number"
													class="w-full"
													v-model="resource.time_window.soft_time_window.cost_per_hour_after"
													name="penaltyForLateness"
													@blur="validatePerCost()"
													@keypress="validateAmountNumber"
												/>
											</div>
										</div>
									</form>
								</vx-card>
							</div>
						</div>
						<vs-alert v-else class="mb-5" color="#a3a1a1" :active.sync="activeAlert">
							<span> {{ $t("TimeWindow.NoAssignedTimeWindows") }} </span>
						</vs-alert>
					</vx-card>
				</div>
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<vx-card style="height: 100%" :cardBorder="true" :noShadow="true">
						<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
							<vs-tab :label="$t('Routing.RouteResult.Capacities')">
								<div class="float-right">
									<vs-button
										class="ml-2 mr-2 font-bold"
										color="primary"
										icon-pack="feather"
										icon="icon-plus"
										type="flat"
										@click.prevent="showPromptDemands()"
										><small style="font-size: 14px">{{ $t("Teams.Form.Add") }}</small>
									</vs-button>
								</div>
								<vs-table :data="propertiesListDemand" noDataText="">
									<template slot="thead">
										<vs-th>{{ $t("Routing.Table.Name") }}</vs-th>
										<vs-th>{{ $t("ResourceModule.Create.CapacityValue") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>

									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
											<vs-td :data="data[indextr].amount">{{ data[indextr].amount }}</vs-td>
											<vs-td>
												<feather-icon
													v-if="validateErrorPropertyArray('capacity', indextr).length > 0"
													icon="AlertCircleIcon"
													svgClasses="h-5 w-5 text-danger ml-2 cursor-pointer"
													:title="$t('ManualData.ShowErrors')"
													@click.prevent="
														showPromptErrorArray(
															'capacity',
															indextr,
															$t('Routing.RouteResult.Capacities')
														)
													"
												/>
												<feather-icon
													icon="EditIcon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="editSelectDemand(data[indextr], indextr)"
												/>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItemDemand(data[indextr], indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									:title="$t('PropertyDefinition')"
									:active.sync="showPromptDemand"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormDemand"
									@accept="addPropertyDemand(resource.capacity)"
								>
									<div class="vx-row">
										<div class="vx-col w-full">
											<small class="date-label cursor-pointer">
												{{ $t("Routing.Table.Name") }}
											</small>
											<vs-input
												v-model.trim="resource.capacity.name"
												class="w-full"
												name="name"
												:vs-placeholder="$t('Routing.Table.Name')"
												:placeholder="$t('Routing.Table.Name')"
												:disabled="isUpdateDemand"
											/>
										</div>
										<div class="vx-col w-full mt-2">
											<small class="date-label">{{
												$t("ResourceModule.Create.CapacityValue")
											}}</small>
											<vs-input
												v-model.trim="resource.capacity.amount"
												class="w-full"
												type="text"
												:placeholder="
													$t(
														'ResourceModule.CapacitiesActivities.CapacityValidMessages.EnterAmount'
													)
												"
												:vs-placeholder="
													$t(
														'ResourceModule.CapacitiesActivities.CapacityValidMessages.EnterAmount'
													)
												"
												@keypress="validateAmountNumber"
											/>
										</div>
									</div>
								</vs-prompt>
							</vs-tab>
							<vs-tab :label="$t('Skills.Skills')">
								<div class="float-right">
									<vs-button
										class="ml-2 mr-2 font-bold"
										color="primary"
										icon-pack="feather"
										icon="icon-plus"
										type="flat"
										@click.prevent="showPromptSkills()"
										><small style="font-size: 14px">{{ $t("Teams.Form.Add") }}</small>
									</vs-button>
								</div>
								<vs-table :data="propertiesListSkill" noDataText="">
									<template slot="thead">
										<vs-th>{{ $t("Name") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>

									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr]">{{ data[indextr] }}</vs-td>
											<vs-td>
												<feather-icon
													v-if="validateErrorPropertyArray('skills', indextr).length > 0"
													icon="AlertCircleIcon"
													svgClasses="h-5 w-5 text-danger ml-2 cursor-pointer"
													:title="$t('ManualData.ShowErrors')"
													@click.prevent="
														showPromptErrorArray('skills', indextr, $t('Skills.Skills'))
													"
												/>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItemSkill(indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									:title="$t('PropertyDefinition')"
									:active.sync="showPromptSkill"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormSkill"
									@accept="addPropertySkill(resource.skill)"
								>
									<div class="vx-row">
										<div class="vx-col w-full mt-2">
											<small class="date-label">{{ $t("Name") }}</small>
											<vs-input
												v-model.trim="resource.skill"
												class="w-full"
												type="text"
												:placeholder="$t('Name')"
												:vs-placeholder="$t('CompanyConfValueAddValidMessage')"
											/>
										</div>
									</div>
								</vs-prompt>
							</vs-tab>
							<vs-tab :label="$t('Breaks')">
								<div class="float-right">
									<vs-button
										class="ml-2 mr-2 font-bold"
										color="primary"
										icon-pack="feather"
										icon="icon-plus"
										type="flat"
										@click.prevent="showPromptBreaks()"
										><small style="font-size: 14px">{{ $t("Teams.Form.Add") }}</small>
									</vs-button>
								</div>
								<vs-table :data="propertiesListBreak" noDataText="">
									<template slot="thead">
										<vs-th>{{ $t("CompanyCreate.InitDate") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.InitHour") }}</vs-th>
										<vs-th>{{ $t("CompanyCreate.EndDate") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.EndHour") }}</vs-th>
										<vs-th>{{ $t("MinBreakDuration") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>
									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr].init_date_window">{{
												data[indextr].init_date_window
											}}</vs-td>
											<vs-td :data="data[indextr].init_hour_window">{{
												data[indextr].init_hour_window
											}}</vs-td>
											<vs-td :data="data[indextr].end_date_window">{{
												data[indextr].end_date_window
											}}</vs-td>
											<vs-td :data="data[indextr].end_hour_window">{{
												data[indextr].end_hour_window
											}}</vs-td>
											<vs-td :data="data[indextr].min_break_hours">{{
												formatMinBreakDuration(data[indextr])
											}}</vs-td>
											<vs-td>
												<feather-icon
													v-if="validateErrorPropertyArray('breaks', indextr).length > 0"
													icon="AlertCircleIcon"
													svgClasses="h-5 w-5 text-danger ml-2 cursor-pointer"
													:title="$t('ManualData.ShowErrors')"
													@click.prevent="
														showPromptErrorArray('breaks', indextr, $t('Breaks'))
													"
												/>
												<feather-icon
													icon="EditIcon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="editSelectBreak(data[indextr], indextr)"
												/>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItemBreak(indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									class="prompt-content--medium"
									:title="$t('PropertyDefinition')"
									:active.sync="showPromptBreak"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormBreak"
									@accept="addPropertyBreak(resource.breaks)"
								>
									<div class="vx-row">
										<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
											<small class="date-label">{{ $t("CompanyCreate.InitDate") }}</small>
											<datepicker
												v-model="resource.breaks.init_date_window"
												name="initDate"
												v-validate="'validatorInitDate'"
												:language="$vs.rtl ? langHe : langEn"
												:disabledDates="disabledDatesTo"
												:placeholder="$t('Select')"
											></datepicker>
											<span class="text-danger text-sm" v-show="errors.has('initDate')">{{
												$t("BreakForm.ErrorMessages.DateInitError")
											}}</span>
										</div>
										<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
											<small class="date-label">{{ $t("CompanyCreate.EndDate") }}</small>
											<datepicker
												name="endDate"
												v-validate="'validatorEndDate'"
												v-model="resource.breaks.end_date_window"
												:language="$vs.rtl ? langHe : langEn"
												:disabledDates="disabledDatesTo"
												:placeholder="$t('Select')"
											></datepicker>
											<span class="text-danger text-sm" v-show="errors.has('endDate')">{{
												$t("BreakForm.ErrorMessages.DateInitError")
											}}</span>
										</div>
										<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
											<small class="date-label">{{ $t("Routing.Table.InitHour") }}</small>
											<flat-pickr
												name="dataHourInit"
												v-validate="'validatorInitHour'"
												class="w-full"
												v-model="resource.breaks.init_hour_window"
												:config="configdateTimePicker"
												:placeholder="$t('SelectInitTime')"
											/>
											<span class="text-danger text-sm" v-show="errors.has('dataHourInit')">{{
												$t("BreakForm.ErrorMessages.ValidInitHour")
											}}</span>
										</div>
										<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
											<small class="date-label">{{ $t("Routing.Table.EndHour") }}</small>
											<flat-pickr
												v-model="resource.breaks.end_hour_window"
												v-validate="'validatorEndHour'"
												name="dataHourEnd"
												class="w-full"
												:config="configdateTimePicker"
												:placeholder="$t('SelectEndTime')"
											/>
											<span class="text-danger text-sm" v-show="errors.has('dataHourEnd')">{{
												$t("BreakForm.ErrorMessages.ValidEndHour")
											}}</span>
										</div>
									</div>
									<div class="vx-row mt-2">
										<div class="vx-col w-full">
											<small class="date-label">{{ $t("MinBreakDuration") }}</small>
											<div class="flex flex-row justify-between">
												<vs-input-number
													v-model="resource.min_break_hours"
													class="w-1/4 mr-4"
													name="minBreakDuration"
													v-validate="'validatorMinBreakDuration'"
													:label="$t('RouterSelection.Hours')"
													:min="0"
													@keypress="validateInputNumber"
												/>
												<vs-input-number
													v-model="resource.min_break_minutes"
													class="w-full"
													name="minBreakDuration"
													v-validate="'validatorMinBreakDuration'"
													:label="$t('RouterSelection.Minutes')"
													:min="0"
													:max="59"
													@keypress="validateInputNumberMinutes"
												/>
												<vs-input-number
													v-model="resource.min_break_seconds"
													class="w-full ml-4"
													name="minBreakDuration"
													v-validate="'validatorMinBreakDuration'"
													:label="$t('RouterSelection.Seconds')"
													:min="0"
													:max="59"
													@keypress="validateInputNumberSeconds"
												/>
											</div>
											<span class="text-danger text-sm" v-show="errors.has('minBreakDuration')">{{
												$t("BreakForm.ErrorMessages.ValidMinBreakDuration")
											}}</span>
										</div>
									</div>
								</vs-prompt>
							</vs-tab>
							<vs-tab
								v-if="optimizersList.length > 0 && optimizersList.includes('TOUR_PLANNING')"
								:label="$t('Territories.Territories')"
							>
								<div class="flex items-center justify-between">
									<div class="flex items-center justify-start">
										<label class="vs-input--label">{{
											$t("Territories.AllowOperationsOutsideTheAssignedArea")
										}}</label>
										<vs-switch class="ml-2" color="success" v-model="resource.strict_territories" />
									</div>
									<vs-button
										class="ml-2 mr-2 font-bold"
										color="primary"
										icon-pack="feather"
										icon="icon-plus"
										type="flat"
										@click.prevent="showPromptTerritories()"
										><small style="font-size: 14px">{{ $t("Teams.Form.Add") }}</small>
									</vs-button>
								</div>
								<vs-table :data="propertiesListTerritory" noDataText="">
									<template slot="thead">
										<vs-th>{{ $t("Territories.TerritoryID") }}</vs-th>
										<vs-th>{{ $t("Priority") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>

									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr].id">{{ data[indextr].id }}</vs-td>
											<vs-td :data="data[indextr].priority">{{ data[indextr].priority }}</vs-td>
											<vs-td>
												<feather-icon
													icon="EditIcon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="editSelectTerritory(data[indextr], indextr)"
												/>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItemTerritory(indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									:title="$t('PropertyDefinition')"
									:active.sync="showPromptTerritory"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormTerritory"
									@accept="addPropertyTerritory(resource.territories)"
								>
									<div class="vx-row">
										<div class="vx-col w-full">
											<small class="date-label cursor-pointer">{{
												$t("Territories.TerritoryID")
											}}</small>
											<vs-input
												v-model.trim="resource.territories.id"
												class="w-full"
												:disabled="isUpdateTerritory"
												@keypress="validateInputName"
											/>
										</div>
										<div class="vx-col w-full mt-4 flex items-center">
											<small class="date-label mr-2">{{ $t("Priority") }}</small>
											<vs-input-number
												v-model="resource.territories.priority"
												class="w-1/3"
												min="0"
												max="5"
											/>
										</div>
									</div>
								</vs-prompt>
							</vs-tab>
							<vs-tab :label="$t('AdditionalFields')">
								<div class="float-right">
									<vs-button
										class="ml-2 mr-2 font-bold"
										color="primary"
										type="flat"
										icon-pack="feather"
										icon="icon-plus"
										@click.prevent="showPrompt()"
										>{{ $t("Add") }}
									</vs-button>
								</div>
								<vs-table :data="propertiesList" noDataText="">
									<template slot="thead">
										<vs-th>{{ $t("Label") }}</vs-th>
										<vs-th>{{ $t("Value") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>

									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr].label">{{ data[indextr].label }}</vs-td>
											<vs-td :data="data[indextr].value">{{ data[indextr].value }}</vs-td>
											<vs-td>
												<feather-icon
													v-if="
														validateErrorPropertyArray('additional_info', indextr).length >
														0
													"
													icon="AlertCircleIcon"
													svgClasses="h-5 w-5 text-danger ml-2 cursor-pointer"
													:title="$t('ManualData.ShowErrors')"
													@click.prevent="
														showPromptErrorArray(
															'additional_info',
															indextr,
															$t('AdditionalFields')
														)
													"
												/>
												<feather-icon
													icon="EditIcon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="editSelect(data[indextr], indextr)"
												/>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItem(data[indextr], indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									:title="$t('PropertyDefinition')"
									:active.sync="showPromptField"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormAdditionalFields"
									@accept="addProperty(property)"
								>
									<div class="vx-row mt-2">
										<div class="vx-col w-full mt-2">
											<small class="date-label cursor-pointer">
												{{ $t("Label") }}: ({{ $t("LabelHelp") }})
												<i
													class="material-icons ml-1 text-center"
													style="font-size: 14px"
													:title="$t('AcceptsNumbersAndTheDashSign')"
												>
													info
												</i>
											</small>
											<vs-input
												v-model.trim="property.label"
												class="w-full"
												name="label"
												:vs-placeholder="$t('Label')"
												:placeholder="$t('Label')"
												:disabled="isUpdate"
												@keypress="validateKeyAdditionalInfo"
											/>
										</div>
										<div class="vx-col w-full">
											<small class="date-label">{{ $t("ResourceModule.Create.Type") }}</small>
											<v-select
												v-model="property.type"
												name="type"
												:options="type"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:clearable="false"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
													<template v-else>
														{{ $t("NoResultsFound") }}
													</template>
												</template>
											</v-select>
										</div>
										<div class="vx-col w-full mt-2">
											<small class="date-label">{{ $t("Value") }}: ({{ $t("TagValue") }})</small>
											<flat-pickr
												v-if="property.type.value === 'datetime'"
												class="w-full"
												v-model="property.value"
												:placeholder="$t('Select')"
												:config="configdateTimePicker"
											/>
											<vs-input
												v-else
												v-model.trim="property.value"
												class="w-full"
												:type="property.type.value"
												:placeholder="
													property.type.value === 'date' || property.type.value === 'time'
														? ''
														: $t('Value')
												"
												:vs-placeholder="$t('Value')"
											/>
										</div>
									</div>
								</vs-prompt>
							</vs-tab>
						</vs-tabs>
					</vx-card>
				</div>
			</div>
		</vue-perfect-scrollbar>
		<div class="vx-row mt-4 sidebar-actions-footer">
			<div class="vx-col w-full">
				<div class="flex flex-wrap items-center justify-end">
					<vs-button class="ml-auto" color="danger" @click.stop="closeSidebarAddResource()">{{
						$t("Cancel")
					}}</vs-button>
					<vs-button class="ml-4" :disabled="!validateForm" @click.prevent="addResource()">{{
						$t("Crud.Update")
					}}</vs-button>
				</div>
			</div>
		</div>

		<!-- MAP COMPONENT -->
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="formatData.cx === 0 && formatData.cy === 0 ? false : true"
			:title="vsPopupTitle"
			:active.sync="popupMapMounted"
		>
			<div class="vx-row">
				<div :class="formatData.cx === 0 && formatData.cy === 0 ? 'vx-col w-full' : 'vx-col w-full md:w-1/2'">
					<vx-card no-shadow card-border>
						<vs-alert color="success" vs-icon="new_releases" class="mb-2" :active.sync="geoAlert">
							{{ $t("Routing.FromMapTitle") }}
						</vs-alert>
						<popup-map
							v-if="popupMapMounted"
							:name="mapConfig.name"
							:latitude="mapConfig.latitude"
							:longitude="mapConfig.longitude"
							:zoom="mapConfig.zoom"
							:theme="mapConfig.theme"
							:calledFrom="mapConfig.calledFrom"
							:changeCursorEnable="true"
							:getCallbackClick="callbackClick"
							:getCoordinatesDrag="getCoordinatesDrag"
							@getInstanceMapEmit="getInstanceMap"
						></popup-map>
					</vx-card>
				</div>
				<div v-if="formatData.cx !== 0 && formatData.cy !== 0" class="vx-col w-full md:w-1/2">
					<vx-card no-shadow card-border>
						<form class="form-content">
							<vs-alert
								color="success"
								closable
								icon-pack="feather"
								close-icon="icon-x"
								:active.sync="geoAlertAddress"
							>
								{{
									$t("Routing.Map.GeoreferencingByAddress") +
									" " +
									$t("AssignedTeams.ClickOnButton").toLocaleLowerCase() +
									" " +
									$t("Routing.Map.Georeference").toLocaleLowerCase()
								}}
								<feather-icon svgClasses="h-4 w-4" icon="GlobeIcon" />
								{{
									$t("Routing.Map.DiscardTheChanges").toLocaleLowerCase() +
									" " +
									$t("AssignedTeams.ClickOnButton").toLocaleLowerCase() +
									" " +
									$t("Cancel").toLocaleLowerCase()
								}}
								<feather-icon svgClasses="h-4 w-4" icon="XIcon" />
							</vs-alert>
							<div class="vx-row">
								<div class="vx-col w-full">
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ $t("Address") }}</label>
											<vx-input-group>
												<vs-input
													v-model="formatData.address"
													name="item-address"
													v-validate="'required'"
													:disabled="isDisabled"
													@change="(showGeoAgain = true), (isDisabled = false)"
												/>
												<template slot="append">
													<div class="append-text btn-addon">
														<vs-button
															v-if="!isDisabled"
															color="warning"
															icon-pack="feather"
															icon="icon-x"
															:title="$t('Cancel')"
															@click.prevent="cancelAction"
														></vs-button>
														<vs-button
															v-if="!isDisabled"
															color="primary"
															icon-pack="feather"
															icon="icon-globe"
															:title="$t('Routing.Map.GeoCoordinates')"
															@click.prevent="geoCoder"
														></vs-button>
														<vs-button
															v-else
															:title="$t('Edit') + ' ' + $t('Address')"
															icon-pack="feather"
															icon="icon-edit"
															@click.prevent="
																(isDisabled = !isDisabled),
																	(geoAlertAddress = true),
																	(showButtonAddCoordinates = false)
															"
														/>
													</div>
												</template>
											</vx-input-group>
											<span class="text-danger text-sm" v-show="errors.has('item-address')">{{
												$t("CompanyModule.Form.ValidMessages.Address")
											}}</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ $t("Country") }}</label>
											<v-select
												v-model="selectedCountry"
												v-validate="'required'"
												name="country"
												:clearable="false"
												:disabled="
													formatData.address === '' ||
													formatData.address === null ||
													formatData.address === undefined
												"
												:options="countriesOptions"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
													<template v-else>
														{{ $t("NoResultsFound") }}
													</template>
												</template>
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('country')"
												>{{ $t("ResourceModule.BasicInfoForm.ValidMessages.Country") }}
											</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ getPoliticalDivision.department }}</label>
											<v-select
												v-model="selectedDepartment"
												name="departments"
												:loading="departments.length <= 0 && selectedCountry ? true : false"
												:clearable="false"
												:disabled="
													departments.length <= 0 ||
													formatData.address === '' ||
													formatData.address === null ||
													formatData.address === undefined ||
													isDisabled
												"
												:options="departments"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
													<template v-else>
														{{ $t("NoResultsFound") }}
													</template>
												</template>
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('departments')"
												>{{
													$t("ValidateField", {
														n: getPoliticalDivision.department.toLowerCase(),
													})
												}}
											</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ getPoliticalDivision.city }}</label>
											<v-select
												v-model="dataCity"
												v-validate="'required'"
												name="cities"
												:loading="
													cities.length <= 0 && selectedDepartment && selectedCountry
														? true
														: false
												"
												:clearable="false"
												:disabled="
													cities.length <= 0 ||
													formatData.address === '' ||
													formatData.address === null ||
													formatData.address === undefined ||
													isDisabled
												"
												:options="cities"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
													<template v-else>
														{{ $t("NoResultsFound") }}
													</template>
												</template>
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('cities')"
												>{{ $t("ValidateField", {n: getPoliticalDivision.city.toLowerCase()}) }}
											</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col md:w-1/2 w-full">
											<vs-input
												class="w-full"
												:label="$t('Routing.Map.Latitude')"
												v-model="formatData.cy"
												name="cy"
												disabled
											/>
											<span class="text-danger text-sm" v-show="errors.has('cy')">{{
												errors.first("cy")
											}}</span>
										</div>
										<div class="vx-col md:w-1/2 w-full">
											<vs-input
												class="w-full"
												:label="$t('Routing.Map.Longitude')"
												v-model="formatData.cx"
												name="cx"
												disabled
											/>
											<span class="text-danger text-sm" v-show="errors.has('cx')">{{
												errors.first("cx")
											}}</span>
										</div>
									</div>
								</div>
							</div>
						</form>
					</vx-card>
				</div>
			</div>
			<div v-if="formatData.cx !== 0 && formatData.cy !== 0 && showButtonAddCoordinates" class="vx-row">
				<div class="vx-col w-full mt-2">
					<div class="flex flex-wrap items-center justify-end">
						<vs-button
							color="success"
							:disabled="formatData.cx === 0 || formatData.cy === 0"
							@click="confirmCoordinates(formatData)"
							>{{ $t("Add") + " " + $t("Routing.Map.Coordinates") }}
						</vs-button>
					</div>
				</div>
			</div>
		</vs-popup>
		<vs-prompt
			color="danger"
			:title="$t('Errors') + ' ' + $t('TypeConfig.Form.Field') + ' ' + titlePromptErrorVisitPoint"
			:active.sync="activePromptErrorVisitPoint"
			:buttons-hidden="true"
		>
			<vs-list>
				<vs-list-item
					v-for="(item, index) of arrayErrors"
					:key="index"
					:title="index + 1 + '. ' + item.message"
				></vs-list-item>
			</vs-list>
		</vs-prompt>
	</div>
</template>

<script>
import {resourceEditMixin} from "../model/ResourceEditMixin.js";

export default {
	mixins: [resourceEditMixin],
};
</script>
<style lang="scss" scoped>
.scroll-area--form {
	margin: auto;
	width: 100%;
	min-height: 300px;
	max-height: calc(100vh - 200px);
	overflow-y: auto;
}
.sidebar-actions-footer {
	position: sticky;
	bottom: 0;
	left: 0;
	width: 100%;
	background: #fff;
	z-index: 10;
	padding: 16px 24px;
	display: flex;
	justify-content: flex-end;
	gap: 16px;
	border-top: 1px solid #eee;
}

/* Responsive adjustments */
@media (max-height: 600px) {
	.scroll-area--form {
		max-height: calc(100vh - 150px);
		min-height: 200px;
	}
}

@media (max-width: 768px) {
	.scroll-area--form {
		max-height: calc(100vh - 180px);
	}
}

/* Custom styles for vs-prompt to make it wider */
.con-vs-dialog .vs-dialog {
	max-width: 600px !important;
}
</style>
